export default {
  // General
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    loading: 'Loading...',
    retry: 'Retry',
    submit: 'Submit',
    search: 'Search',
    clear: 'Clear',
    select: 'Select',
    pleaseSelect: 'Please select',
    noData: 'No data',
    noMore: 'No more data',
    guest: 'Guest',
    free: 'Free'
  },

  // Navigation and page titles
  nav: {
    home: 'Home',
    about: 'About',
    news: 'News',
    profile: 'Profile',
    products: 'Products',
    productList: 'Product List',
    productDetail: 'Product Detail',
    customizeOrder: 'Customize Order',
    orderConfirm: 'Order Confirmation',
    orderList: 'Order List',
    orderDetail: 'Order Detail',
    addressManage: 'Address Management',
    addressEdit: 'Edit Address',
    payment: 'Payment',
    share: 'Share'
  },

  // Product related
  product: {
    // Product types
    inStock: 'In Stock',
    custom: 'Custom',
    presale: 'Pre-sale',
    
    // Product information
    name: 'Product Name',
    price: 'Price',
    originalPrice: 'Original Price',
    deposit: 'Deposit',
    depositLabel: 'Deposit',
    customAmount: 'Custom Amount (Deposit)',
    productAmount: 'Product Amount',
    sales: 'Sold {count} pieces',
    description: 'Description',
    specs: 'Specifications',
    selectSpecs: 'Select Specifications',
    size: 'Size',
    color: 'Color',
    deliveryTime: 'Delivery Time',
    loadingTypes: 'Loading product types...',
    apiResponse: 'API Response:',
    processedData: 'Processed Data:',
    categoriesLoaded: 'Categories loaded successfully:',
    invalidDataFormat: 'API returned data is not in array format:',
    invalidDataFormatError: 'API data format error',
    loadTypesFailed: 'Failed to load product types:',
    errorDetails: 'Error Details:',
    loadTypesFailedMsg: 'Failed to load category data',
    usingDefaultData: 'Using default category data',
    all: 'All',
    women: 'Women',
    men: 'Men',
    accessories: 'Accessories',
    shoes: 'Shoes',
    
    // Product details
    productInfo: 'Product Information',
    productParams: 'Product Parameters',
    sizeChart: 'Size Chart',
    sizeReference: 'Size Reference',
    sizeDetails: 'Size Details',
    customNotice: 'Custom Notice',
    friendlyTips: 'Friendly Tips',
    
    // Product actions
    buyNow: 'Buy Now',
    customNow: 'Customize Now',
    addToCart: 'Add to Cart',
    outOfStock: 'Out of Stock',
    
    // Delivery time
    shipIn24Hours: 'Ships within 24 hours',
    shipInHours: 'Ships within {hours} hours',
    shipInDays: 'Ships within {days} days',
    
    // Product search and filtering
    searchPlaceholder: 'Search products',
    sortBy: 'Sort by',
    comprehensive: 'Comprehensive',
    priceSort: 'Price',
    salesSort: 'Sales',
    ratingSort: 'Rating',
    
    // Product tips
    customProductTip: 'Custom products require careful verification of size information. If you have any questions, please contact customer service.',
    stockProductTip: 'In-stock and pre-sale products require careful verification of size information. It is recommended to refer to the size chart to select the appropriate size. If you have any questions, please contact customer service.',
    
    // Specification selection
    pleaseSelectSpecs: 'Please select specifications',
    specDetails: 'Specification Details',
    paramDetails: 'Parameter Details',
    specParamCombination: 'Specification Parameter Combination',
    specCombination: 'Specification Combination',
    paramCombination: 'Parameter Combination',
    viewDetails: 'View Details',
    
    // Size related
    heightWeight: 'Height\\Weight',
    bodyPart: 'Body',
    sizeNumber: 'Size',
    referenceOnly: 'The above data is for reference only. Actual sizes may vary due to fabric and craftsmanship.',
    
    // Custom related
    customRequirements: 'Custom Requirements',
    customParams: 'Custom Parameters',
    noCustomNotice: 'No custom notice available',
    
    // Image related
    productImage: 'Product Image',
    noImage: 'No image available',
    swipeUpForDetails: 'Swipe up to view details'
  },

  // User related
  user: {
    // Login status
    notLoggedIn: 'Not logged in',
    loggedIn: 'Logged in',
    loginRequired: 'Please log in first',
    loginSuccess: 'Login successful!',
    logoutSuccess: 'Logged out successfully',
    
    // Login methods
    wechatLogin: 'WeChat Login',
    wechatQRLogin: 'WeChat QR Login',
    wechatAuth: 'WeChat Authorization',
    bindPhone: 'Bind Phone Number',
    clickToLogin: 'Click to log in with WeChat',
    clickToBind: 'Click to bind phone number',
    
    // User information
    userInfo: 'User Information',
    nickname: 'Nickname',
    avatar: 'Avatar',
    phone: 'Phone Number',
    wechatUser: 'WeChat User',
    clickAvatarToLogout: 'Click avatar to log out',
    
    // Login related tips
    loggingIn: 'Logging in...',
    loginFailed: 'Login failed',
    pleaseOpenInWechat: 'Please open in WeChat',
    redirectingToWechat: 'Redirecting to WeChat authorization...',
    scanQRToLogin: 'Scan QR code to log in',
    confirmLoginOnPhone: 'Please confirm login on your phone after scanning',
    qrExpired: 'QR code expired, please regenerate',
    regenerateQR: 'Regenerate',
    generatingQR: 'Generating QR code...',
    openWechatLogin: 'Open WeChat Login Page'
  },

  // Order related
  order: {
    // Order status
    myOrders: 'My Orders',
    allOrders: 'All Orders',
    pendingPayment: 'Pending Payment',
    pendingShipment: 'Pending Shipment',
    pendingReceive: 'Pending Receive',
    completed: 'Completed',
    
    // Order actions
    createOrder: 'Create Order',
    confirmOrder: 'Confirm Order',
    submitOrder: 'Submit Order',
    submitCustomOrder: 'Submit Custom Order',
    payNow: 'Pay Now',
    confirmReceive: 'Confirm Receipt',
    viewOrder: 'View Order',
    
    // Order information
    orderNumber: 'Order Number',
    orderTime: 'Order Time',
    orderAmount: 'Order Amount',
    orderStatus: 'Order Status',
    orderRemark: 'Order Remark',
    orderRemarkPlaceholder: 'Optional, please enter order remarks',
    
    // Order details
    orderDetail: 'Order Details',
    productInfo: 'Product Information',
    orderInfo: 'Order Information',
    paymentInfo: 'Payment Information',
    logisticsInfo: 'Logistics Information',
    
    // Payment related
    paymentMethod: 'Payment Method',
    offlinePayment: 'Offline Payment',
    airwallexPay: 'Airwallex',
    totalAmount: 'Total Amount',
    actualPayment: 'Actual Payment',
    
    // Delivery related
    deliveryMethod: 'Delivery Method',
    expressDelivery: 'Express Delivery',
    storePickup: 'Store Pickup',
    deliveryFee: 'Delivery Fee',
    deliveryTime: 'Delivery Time',
    workDaysDelivery: '{days} working days delivery',
    storePickupFree: 'Store pickup, free shipping'
  },

  // Address related
  address: {
    // Address management
    addressManagement: 'Address Management',
    shippingAddress: 'Shipping Address',
    selectAddress: 'Select Address',
    addAddress: 'Add Address',
    editAddress: 'Edit Address',
    deleteAddress: 'Delete Address',
    setDefault: 'Set as Default',
    defaultAddress: 'Default',
    
    // Address information
    consignee: 'Consignee',
    phoneNumber: 'Phone Number',
    region: 'Region',
    detailAddress: 'Detailed Address',
    postalCode: 'Postal Code',
    
    // Address tips
    pleaseSelectAddress: 'Please select shipping address',
    noAddress: 'No shipping address available',
    addressRequired: 'Shipping address is required',
    
    // Address form
    consigneePlaceholder: 'Please enter consignee name',
    phonePlaceholder: 'Please enter phone number',
    regionPlaceholder: 'Please select region',
    detailPlaceholder: 'Please enter detailed address',
    postalPlaceholder: 'Please enter postal code',
    
    // Phone number validation
    phoneNumberTooLong: '电话号码过长（最多{maxLength}个字符），将被截断'
  },

  // Share related
  share: {
    shareTitle: 'Share',
    shareTo: 'Share to',
    shareToFriends: 'Share to Friends',
    shareToMoments: 'Share to Moments',
    sharePreview: 'Share Preview',
    shareSuccess: 'Share configured successfully, please click the menu in the upper right corner to share',
    shareFailed: 'Share configuration failed, please try again',
    configuring: 'Configuring share...',
    shareComplete: 'Share configuration complete, please click the menu in the upper right corner to share',
    
    // 默认分享内容
    defaultTitle: '蒙古丽人商城',
    defaultDesc: '甄选蒙古风格服饰与定制产品',
    
    // Share tips
    pleaseOpenInWechat: 'Please open in WeChat',
    shareConfigComplete: 'Share configuration complete, please click the menu in the upper right corner to share to friends',
    shareMomentsComplete: 'Share configuration complete, please click the menu in the upper right corner to share to moments'
  },

  // Customer service related
  service: {
    customerService: 'Customer Service',
    contactService: 'Contact Customer Service',
    scanQRForService: 'Scan QR code to add official customer service',
    connectingService: 'Connecting you to customer service...',
    ifYouHaveQuestions: 'If you have any questions',
    scanToAddService: 'Please scan to add official customer service'
  },

  // Form related
  form: {
    required: 'This field is required',
    pleaseEnter: 'Please enter {field}',
    pleaseSelect: 'Please select {field}',
    pleaseComplete: 'Please complete {field}',
    invalidFormat: 'Invalid format',
    
    // Signature related
    signatureConfirm: 'Signature Confirmation',
    pleaseSignAbove: 'Please sign in the area above',
    clearSignature: 'Clear',
    signatureRequired: 'Signature is required'
  },

  // Errors and tips
  error: {
    loadFailed: 'Load failed',
    loadFailedRetry: 'Load failed, please retry',
    networkError: 'Network error',
    systemError: 'System error',
    operationFailed: 'Operation failed',
    dataError: 'Data error',
    
    // Product related errors
    productNotFound: 'Product not found',
    productIdMissing: 'Product ID is missing',
    specSelectionRequired: 'Please select product specifications',
    insufficientStock: 'Insufficient stock',
    
    // User related errors
    loginFailed: 'Login failed, please try again',
    authFailed: 'Authorization failed, please check domain configuration',
    authTimeout: 'Authorization timeout, please try again',
    
    // Order related errors
    orderCreateFailed: 'Failed to create order',
    orderSubmitFailed: 'Failed to submit order',
    addressRequired: 'Please select shipping address',
    customParamsRequired: 'Please complete custom requirements',
    
    // Address related errors
    addressLoadFailed: 'Failed to load address list',
    addressSaveFailed: 'Failed to save address',
    
    // Other errors
    shareConfigFailed: 'Share configuration failed',
    qrGenerateFailed: 'Failed to generate QR code, please try again',
    componentLoadFailed: 'Component load failed, please try again later'
  },

  // Function menu
  menu: {
    addressManagement: 'Address Management',
    orderHistory: 'Order History',
    customerService: 'Customer Service',
    settings: 'Settings',
    about: 'About Us'
  },

  // Others
  misc: {
    // Time related
    justNow: 'Just now',
    minutesAgo: '{minutes} minutes ago',
    hoursAgo: '{hours} hours ago',
    daysAgo: '{days} days ago',
    
    // Quantity related
    pieces: 'pieces',
    items: 'items',
    total: 'Total',
    subtotal: 'Subtotal',
    
    // Status related
    enabled: 'Enabled',
    disabled: 'Disabled',
    available: 'Available',
    unavailable: 'Unavailable',
    
    // Action related
    viewAll: 'View All',
    showMore: 'Show More',
    collapse: 'Collapse',
    expand: 'Expand'
  }
}
